import React, { useState } from 'react'
import SideNav from '../components/SideNav';
//codex-- Keep the office wall as the default while offering the independent team feed.
import OfficeWalls from '../components/OfficeWalls';
import Comment from '../components/Comment';
import { MinusIcon } from '@heroicons/react/24/outline';
import DayOff from '../components/DayOff';
import Alerts from '../components/Alerts';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ImageLocationCp from '../components/ImageLocationCp';
import NewsUpdateCp from '../components/NewsUpdateCp';
// import { Nav } from 'react-bootstrap';

const HomePage = () => {
  const [showSidebar, setShowSidebar] = useState(false);

  return (
    <>
    {/* <div className="max-w-[1220px] mx-auto grid grid-cols-1 md:grid-cols-[200px_minmax(540px,_1fr)_260px] gap-x-4"> */}
    <div className="max-w-[1200px] mx-auto grid grid-cols-1 md:grid-cols-[220px_minmax(500px,_1fr)_270px] gap-x-6">
      {/* <div className="mx-auto max-w-5xl px-4 sm:px-6 lg:px-8"></div> */}
      {/* <!-- Side Nav: 200px, hidden on small screens --> */}
      <div className="block">
        {/* <div className='pt-6 pr-3'>
          <SideNav />
        </div> */}
        {/* Toggle button */}
        {/* <button
          className="md:hidden p-2 fixed top-2 left-2 z-50 bg-gray-100 rounded shadow"
          onClick={() => setShowSidebar(prev => !prev)}
        >
          ☰
        </button> */}

        {/* SideNav */}
        {/* {showSidebar && (
          <div className="fixed inset-0 z-40 bg-white w-[250px] shadow-lg p-4 md:hidden">
            <SideNav />
          </div>
        )}         */}
        <div className="hidden md:block">
          <div className="pt-6 pr-3">
            <SideNav />
          </div>
        </div>

      </div>
      
      {/* <!-- Main Content: Expand on small screens --> */}
      <div className=" p-4">
        {/*codex-- Preserve all home widgets and defer Tech Wall until the user selects it. */}
        <OfficeWalls />
      </div>
      
      {/* <!-- Widgets: 200px, hidden on small screens --> */}
      <div className="hidden md:block ">
        <div className='pt-4'>
          <div className='border-2'>
            <DayOff />
          </div>
        <br/>
        <NewsUpdateCp />
        <br/>
          <Alerts />
        </div>
      </div>
    </div>
    <br/>
    </>
  )
} 

export default HomePage
